"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/hooks/use-auth";
import { useModalSequenceStore } from "@/stores/modal-sequence-store";
import { useEffect } from "react";

/**
 * ModalSequenceHydrator — a thin component that drives the modal-sequence-store
 * by reacting to auth state changes. No longer a Context provider.
 *
 * Mount this once in the app tree as a sibling (e.g. in layout.tsx).
 */
export function ModalSequenceHydrator() {
  const $ = _c(5);
  const {
    isAuthenticated,
    user
  } = useAuth();
  const evaluate = useModalSequenceStore(_temp);
  let t0;
  let t1;
  if ($[0] !== evaluate || $[1] !== isAuthenticated || $[2] !== user) {
    t0 = () => {
      evaluate({
        isAuthenticated,
        userId: user?.id ?? null,
        hasEmails: Boolean(user?.emails && user.emails.length > 0),
        hasGroups: Boolean(user?.groups && user.groups.length > 0)
      });
    };
    t1 = [isAuthenticated, user, evaluate];
    $[0] = evaluate;
    $[1] = isAuthenticated;
    $[2] = user;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  return null;
}

/**
 * Hook to access the modal sequence state.
 * Reads from the Zustand store instead of React Context.
 */
function _temp(s) {
  return s.evaluate;
}
export function useModalSequence() {
  const $ = _c(9);
  const activeModal = useModalSequenceStore(_temp2);
  const completeEmailModalAction = useModalSequenceStore(_temp3);
  const completeRelationshipModal = useModalSequenceStore(_temp4);
  const {
    user
  } = useAuth();
  let t0;
  if ($[0] !== completeEmailModalAction || $[1] !== user) {
    t0 = () => {
      const hasGroups = Boolean(user?.groups && user.groups.length > 0);
      completeEmailModalAction(hasGroups);
    };
    $[0] = completeEmailModalAction;
    $[1] = user;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const completeEmailModal = t0;
  const t1 = activeModal === "email";
  const t2 = activeModal === "relationship";
  let t3;
  if ($[3] !== activeModal || $[4] !== completeEmailModal || $[5] !== completeRelationshipModal || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      activeModal,
      isEmailModalActive: t1,
      isRelationshipModalActive: t2,
      completeEmailModal,
      completeRelationshipModal
    };
    $[3] = activeModal;
    $[4] = completeEmailModal;
    $[5] = completeRelationshipModal;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp4(s_1) {
  return s_1.completeRelationshipModal;
}
function _temp3(s_0) {
  return s_0.completeEmailModal;
}
function _temp2(s) {
  return s.activeModal;
}